var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22,
    stroke: "#2351DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9297 18.4375C31.7109 17.8516 32.4141 17.1484 32.9609 16.3281C32.2578 16.6406 31.4375 16.875 30.6172 16.9531C31.4766 16.4453 32.1016 15.6641 32.4141 14.6875C31.6328 15.1562 30.7344 15.5078 29.8359 15.7031C29.0547 14.8828 28 14.4141 26.8281 14.4141C24.5625 14.4141 22.7266 16.25 22.7266 18.5156C22.7266 18.8281 22.7656 19.1406 22.8438 19.4531C19.4453 19.2578 16.3984 17.6172 14.3672 15.1562C14.0156 15.7422 13.8203 16.4453 13.8203 17.2266C13.8203 18.6328 14.5234 19.8828 15.6562 20.625C14.9922 20.5859 14.3281 20.4297 13.7812 20.1172V20.1562C13.7812 22.1484 15.1875 23.7891 17.0625 24.1797C16.75 24.2578 16.3594 24.3359 16.0078 24.3359C15.7344 24.3359 15.5 24.2969 15.2266 24.2578C15.7344 25.8984 17.2578 27.0703 19.0547 27.1094C17.6484 28.2031 15.8906 28.8672 13.9766 28.8672C13.625 28.8672 13.3125 28.8281 13 28.7891C14.7969 29.9609 16.9453 30.625 19.2891 30.625C26.8281 30.625 30.9297 24.4141 30.9297 18.9844C30.9297 18.7891 30.9297 18.6328 30.9297 18.4375Z",
    fill: "#2351DC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.9904b5db9ee8d2e3a6e8e1d673d859ce.svg";
export { ForwardRef as ReactComponent };